import React, { useState } from "react";
import SvgIcn from "../../data/IconCompo";
import { categoryIcon } from "../../utils/dashboardUtils";
import { BACKEND_URL } from "../../config";

const ItemsTable = ({
  items,
  handleDeleteItemClick,
  imgError,
  setImgError,
  handleEditItemClick,
  onSort, // New prop for handling sorting
}) => {
  const [sortConfig, setSortConfig] = useState({
    key: "name",
    direction: "ascending",
  });

  const handleSort = (key) => {
    let direction = "ascending";
    if (sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending";
    }
    setSortConfig({ key, direction });
    onSort(key, direction);
  };

  const getSortIcon = (columnName) => {
    if (sortConfig.key !== columnName) {
      return <SvgIcn name="sort" className="sort-icon" />;
    }
    return sortConfig.direction === "ascending" ? (
      <SvgIcn name="sort_up" className="sort-icon active" />
    ) : (
      <SvgIcn name="sort_down" className="sort-icon active" />
    );
  };

  return (
    <>
      <div className="btns-items-box items-header">
        <div
          className="header-item sortable"
          onClick={() => handleSort("category")}
        >
          Cat {getSortIcon("category")}
        </div>
        <div className="header-item">Image</div>
        <div
          className="header-item sortable"
          onClick={() => handleSort("name")}
        >
          Name {getSortIcon("name")}
        </div>
        <div
          className="header-item sortable"
          onClick={() => handleSort("clicks")}
        >
          Clicks {getSortIcon("clicks")}
        </div>
        <div className="header-item">Link</div>
        <div className="header-item">Actions</div>
      </div>

      <div className="users-content">
        {items.map((item, index) => (
          <ItemRow
            key={index}
            item={item}
            index={index}
            imgError={imgError}
            setImgError={setImgError}
            handleDeleteItemClick={handleDeleteItemClick}
            handleEditItemClick={handleEditItemClick}
          />
        ))}
      </div>
    </>
  );
};

const ItemRow = ({
  item,
  index,
  imgError,
  setImgError,
  handleDeleteItemClick,
  handleEditItemClick,
}) => {
  return (
    <div className="dashboard-cell">

      <div className="item-category cell">
        <SvgIcn name={categoryIcon(item.category_id[0]?.name)} />
      </div>

      <div className="imagez_box cell"> 
      {imgError[index] ? (
      <SvgIcn name="items" className="imagez"/> 
      ) : (
        <img
          src={`${BACKEND_URL}/images/items/${item.img}`}
          alt={item.name}
          className="item-image"
          onError={() => {
            console.log("Error loading image");
            setImgError((prev) => {
              const newImgError = [...prev];
              newImgError[index] = true;
              return newImgError;
            });
          }}
        />
      )}
      </div>

      <div className="item-name cell">{item.name}</div>
      {/* <div className="item-platform">{item?.platform?.join(",")}</div>
      <div className="item-tags">{item.tags.join(",")}</div> */}
      <div className="item-likes cell">{item.likes}</div>
      <div className="item-clicks cell">{item.clicks}</div>

      <div className="item-actions cell">
      <button onClick={(e) => { e.stopPropagation(); window.open(item.link, "_blank"); }}>
          <SvgIcn name="view_link" />
        </button>
        <button onClick={() => handleEditItemClick(item)}>
          <SvgIcn name="edit" />
        </button>
        <button onClick={() => handleDeleteItemClick(item)}>
          <SvgIcn name="trash" />
        </button>
      </div>
    </div>
  );
};

export default ItemsTable;
